import { render, staticRenderFns } from "./ArtVideos.vue?vue&type=template&id=4363ed6e&scoped=true&"
import script from "./ArtVideos.vue?vue&type=script&lang=js&"
export * from "./ArtVideos.vue?vue&type=script&lang=js&"
import style0 from "./ArtVideos.vue?vue&type=style&index=0&id=4363ed6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363ed6e",
  null
  
)

export default component.exports